<div class="btn-group"
     dropdown
     placement="bottom right"
     #dropdown="bs-dropdown">
    <button
        id="header-menu"
        dropdownToggle
        appTrackClickButton
        type="button"
        class="dropdown-menu-trigger"
        aria-controls="dropdown-header-menu"
    >
        <img [src]="iconLink" alt="icon-link">
    </button>
    <ul id="dropdown-header-menu" appStopClickPropagation *dropdownMenu class="dropdown-menu dropdown-menu-right"
        role="menu" tabindex="-1" aria-labelledby="header-menu">
        <!-- role="menu" is required here for the WAI-ARIA menu-button pattern; tabindex="-1" makes this element programmatically interactive so it can hold the role; keyboard/click interaction is handled by the <a> elements in ui-link-items -->
        <ui-link-items [dropdown]="dropdown"></ui-link-items>
    </ul>
</div>
